export const GLOBAL_STATE = 'Player'

export const PLAYER_STATE = 'state'
export const PLAYER_PIP = 'pip'
